// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1QsKJ","calendarButtons":"ClockData_calendarButtons__3wjrk"};